import React, { useEffect, useState } from "react";
import "./style.css";
import Navbar from "../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import { getUserPerformanceAsPeopleLead } from "../../api/peopleLeadPerformance/getUserGoalAsPl";
import { useAuthContext } from "../../hooks";
import { Button } from "react-bootstrap";

function Index() {
  const [getMemberPerformance, setGetMemberPerformance] = useState<any[]>([]);
  const auth = useAuthContext();
  const fetchOrguserProjects = async () => {
    await getUserPerformanceAsPeopleLead(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString()
    )
      .then((e) => {
        console.log(e, "hello then");
        setGetMemberPerformance(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchOrguserProjects();
  }, []);
  console.log("pl get", getMemberPerformance);
  const navigate = useNavigate();
  return (
    <>
      <div className="admin_people_dshbrd">
        <div className="emergency_button">
          <Button onClick={() => navigate("empoyee_list")}>
            Emergency PTO
          </Button>
        </div>
        {getMemberPerformance.length > 0 ? (
          getMemberPerformance?.map((data) => {
            return (
              <>
                <div className="employee-list-containers-mag">
                  <div className="profile-list-mag">
                    <div className="employee-image mx-2 w-25"></div>
                    <div className="employee-name mx-2 w-75">{data.Name}</div>
                  </div>
                  <div className="employee-list">{data.Evaluation}</div>
                  <div className="performance-status">
                    <div
                      className="project-lead-approval-status"
                      onClick={() => navigate(`${data?.org_user_id}`)}
                    >
                      View Details
                    </div>
                  </div>
                </div>
              </>
            );
          })
        ) : (
          <div className="alert-messages">
            Only people lead can access this page
          </div>
        )}
      </div>
    </>
  );
}

export default Index;
